export * as default from "./loadingScreenOverlay.service"
export type { LoadingScreenOverlayOptions } from "./loadingScreenOverlay.service"
